<!-- Copyright (c) ArubaCC - All Rights Reserved. -->
@if (loaderService.isActive) {
  <div class="fixed w-screen h-screen bg-black opacity-50 z-[10000]"></div>
  <div class="fixed w-screen h-screen flex justify-center items-center z-[10001]">
    <mat-spinner diameter="45" color="primary" strokeWidth="3"></mat-spinner>
  </div>
}
